module.exports = __webpack_public_path__ + "img/C-info-01.412e08f2.png";